import defineComponent from 'flight';
import checkout from 'static/script/app/ui/checkout2/context/context';
import 'static/script/app/data/member-info';

function CheckoutUI() {

    this.defaultAttrs({
        backToCartOverviewLink: '[data-simple-header-back]',
        paymentOption: '[data-view-checkout-payment-option]',
        selectedPaymentOption: '[data-view-checkout-payment-option]:checked',
        paymentButton: '[data-view-checkout-proceed-to-payment]',
        initData: null
    });

    this._selectPaymentOption = function (e) {
        let selectedPaymentOption = this.select('selectedPaymentOption');
        this._showDescriptionTextForSelectedOption(selectedPaymentOption);
        this._setButtonCaption(e.target.value, selectedPaymentOption.data('is-non-integrated-payment'));
        this._disablePaymentButton();
        this.trigger(document, 'ui:cart:on-payment-option-select', { paymentOption: selectedPaymentOption.val() });
    };

    this._disablePaymentButton = function () {
        let button = this.select('paymentButton');
        button.attr('disabled', true); // @todo Find out why it didnt work with prop? It only worked the first time
        this.on(document, 'data:cart:after-payment-option-selected', this._enablePaymentButton);
    };

    this._enablePaymentButton = function () {
        let button = this.select('paymentButton');
        button.removeAttr('disabled');
        this.off(document, 'data:cart:after-payment-option-selected', this._enablePaymentButton);
    };

    this._showDescriptionTextForSelectedOption = function (selectedPaymentOption) {
        selectedPaymentOption.parents('li')
            .find('[data-view-checkout-payment-option-description]')
            .removeAttr('hidden');

        this.select('paymentOption').not(':checked').parents('li')
            .find('[data-view-checkout-payment-option-description]')
            .attr('hidden', true);
    };

    this._setButtonCaption = function (paymentMethod, isNonIntegratedPayment) {
        let button = this.select('paymentButton'),
            currentCaption = button.val();

        if (isNonIntegratedPayment && currentCaption !== button.data('caption-nonintegrated')) {
            button.val(button.data('caption-nonintegrated'));
        } else if (!isNonIntegratedPayment && currentCaption !== button.data('caption-integrated')) {
            button.val(button.data('caption-integrated'));
        }
    };

    this._initCheckoutEventHandling = function(checkout, model) {
        checkout.observable.on('payment-valid',
            function () {
                let button = document.getElementById('checkout-pay-button');
                button.classList.remove('disabled-action');
                button.onclick = function () {
                    checkout.payment.performPayment({}, model.performPaymentUrl);
                };
            });

        checkout.observable.on('payment-not-valid',
            function () {
                let button = document.getElementById('checkout-pay-button');
                button.classList.add('disabled-action');
                button.onclick = null;
            });
    };

    this.after('initialize', function () {
        this.on('change', {
            paymentOption: this._selectPaymentOption
        });
        this.trigger(document, 'ui:cart:on-payment-option-select', { paymentOption: this.select('selectedPaymentOption').val() });

        let initData = this.attr.initData;
        if (initData.pageSpecificData.Payment) {
            this._initCheckoutEventHandling(checkout, initData.pageSpecificData.Payment);
            checkout.init(initData.pageSpecificData.Payment);
        }
    });
}

export default defineComponent.component(CheckoutUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/cart/view-cartcheckout-ui.js